// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobList-module__job-list___pVEKw{list-style:none;padding-left:0;width:100%;margin-bottom:0}`, "",{"version":3,"sources":["webpack://./src/components/JobList/JobList.module.scss"],"names":[],"mappings":"AAAA,kCACI,eAAA,CACA,cAAA,CACA,UAAA,CACA,eAAA","sourcesContent":[".job-list{\r\n    list-style: none;  \r\n    padding-left: 0;\r\n    width: 100%;\r\n    margin-bottom: 0;\r\n}"],"sourceRoot":""}]);
// Exports
var _1 = `JobList-module__job-list___pVEKw`;
export { _1 as "job-list" };
export default ___CSS_LOADER_EXPORT___;
